export default __webpack_public_path__ + "static/media/SURVIVE_5.e8a977ad.jpg";